/**
 * Product Gallery Images — A/B Test
 * Controlled via PostHog feature flag "product-gallery-images"
 *
 * Control (A): Normal product images (default behavior).
 * Test (B):    Keep first image + variant-attached images.
 *              Remove other images. Insert images from custom.ab_test_images metafield.
 *
 * Events tracked:
 * - product_gallery_ab_shown: test variant is displayed
 */
(function() {
  'use strict';

  function whenPostHogReady(cb) {
    if (window.posthog && typeof window.posthog.onFeatureFlags === 'function') {
      window.posthog.onFeatureFlags(cb);
    } else {
      setTimeout(function() { whenPostHogReady(cb); }, 200);
    }
  }

  whenPostHogReady(function() {
    var flagValue = window.posthog.getFeatureFlag('product-gallery-images');

    if (flagValue !== 'test') {
      return; // Control group — default behavior
    }

    applyPdpGallerySwap();
    applyCollectionCardSwap();

    window.posthog.capture('product_gallery_ab_shown', {
      page_url: window.location.pathname
    });
  });

  function applyPdpGallerySwap() {
    var galleries = document.querySelectorAll('product-gallery[data-ab-gallery]');

    galleries.forEach(function(gallery) {
      var carousel = gallery.querySelector('media-carousel');
      if (!carousel) return;

      // Parse B-variant image data
      var jsonEl = gallery.querySelector('[data-ab-gallery-images]');
      if (!jsonEl) return;

      var bImages;
      try {
        bImages = JSON.parse(jsonEl.textContent);
      } catch (e) {
        return;
      }

      if (!bImages || !bImages.length) return;

      // Guard: only apply once per gallery
      if (gallery.hasAttribute('data-ab-applied')) return;
      gallery.setAttribute('data-ab-applied', 'true');

      var hasSnapCenter = !!carousel.querySelector('.product-gallery__media.snap-center');

      // 1. Remove non-keep A-variant media items from DOM (not just hide)
      //    so carousel indices stay contiguous and match dot indices
      var aItems = Array.from(carousel.querySelectorAll('.product-gallery__media[data-ab-keep="false"]'));
      aItems.forEach(function(item) { item.remove(); });

      // 2. Create and append B-variant media items.
      //    NOTE: intentionally no data-variant-ids / data-media-id on these
      //    elements. The ProductGallery variant filter (see #157) skips media
      //    without data-media-id, so B-injected images remain visible for all
      //    variants — that is the desired behavior for A/B test extras.
      bImages.forEach(function(img) {
        var div = document.createElement('div');
        div.className = 'product-gallery__media' + (hasSnapCenter ? ' snap-center' : '');
        div.setAttribute('data-media-type', 'image');
        div.setAttribute('data-ab-variant', 'b');

        var imgEl = document.createElement('img');
        imgEl.src = img.src;
        imgEl.srcset = img.srcset;
        imgEl.alt = img.alt || '';
        imgEl.sizes = '(max-width: 740px) calc(100vw - 40px), (max-width: 999px) calc(100vw - 64px), min(760px, 42vw)';
        imgEl.loading = 'lazy';
        imgEl.width = img.width;
        imgEl.height = img.height;

        div.appendChild(imgEl);
        carousel.appendChild(div);
      });

      // 3. Rebuild page-dots: remove non-keep dots, add B dots,
      //    then re-insert element to trigger connectedCallback reinit
      //    (this re-caches items and re-attaches all event listeners)
      var pageDotContainers = gallery.querySelectorAll('page-dots');
      pageDotContainers.forEach(function(pd) {
        var aDots = Array.from(pd.querySelectorAll('[data-ab-keep="false"]'));
        aDots.forEach(function(dot) { dot.remove(); });

        // Localized accessible-name template rendered by Liquid,
        // e.g. "Gehe zu Element @INDEX@"
        var labelTemplate = pd.getAttribute('data-ab-dot-label') || '';

        bImages.forEach(function() {
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'tap-area';
          btn.setAttribute('data-ab-variant', 'b');
          btn.setAttribute('aria-current', 'false');
          if (labelTemplate) {
            var srText = document.createElement('span');
            srText.className = 'sr-only';
            var index = pd.querySelectorAll('button').length + 1;
            srText.textContent = labelTemplate.replace('@INDEX@', index);
            btn.appendChild(srText);
          }
          pd.appendChild(btn);
        });

        // Re-insert to trigger disconnectedCallback → connectedCallback
        // so PageDots re-caches items and re-attaches carousel:change listener
        var parent = pd.parentNode;
        var next = pd.nextSibling;
        parent.removeChild(pd);
        parent.insertBefore(pd, next);

        // Clear aria-current on all dots before marking the first one
        pd.querySelectorAll('button[aria-current="true"]').forEach(function(dot) {
          dot.setAttribute('aria-current', 'false');
        });
        var firstDot = pd.querySelector('button:not([hidden])');
        if (firstDot) firstDot.setAttribute('aria-current', 'true');
      });

      // 4. Reset carousel to first slide after browser has re-laid out the DOM.
      //    Using rAF ensures offsetLeft/scrollLeft values are fresh, which matters
      //    when the user was mid-scroll before PostHog resolved.
      requestAnimationFrame(function() {
        // Invalidate cached items so the carousel re-queries the DOM
        carousel._items = null;
        // Use public select() so carousel:change / carousel:settle fire
        // and dependent components (page-dots, product-gallery) stay in sync
        carousel.select(0, { animate: false, force: true });
      });
    });
  }

  function applyCollectionCardSwap() {
    var cards = document.querySelectorAll('product-card[data-ab-secondary-src]');

    cards.forEach(function(card) {
      var secondaryImg = card.querySelector('.product-card__image--secondary');
      if (!secondaryImg) return;

      var newSrc = card.getAttribute('data-ab-secondary-src');
      var newSrcset = card.getAttribute('data-ab-secondary-srcset');

      if (newSrc) secondaryImg.src = newSrc;
      if (newSrcset) secondaryImg.srcset = newSrcset;
    });
  }
})();
